import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import gaTrack from "../lib/gaTrack";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const { refresh } = useAuth();
  const nav = useNavigate();
  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts++;
      try {
        const { data } = await api.get(`/checkout/status/${sid}`);
        if (data.payment_status === "paid") {
          setInfo(data);
          setStatus("paid");
          // GA4 ecommerce: fires once per session_id thanks to status==paid gate
          gaTrack.servicePurchased({
            category: data.metadata?.serviceCategory || data.metadata?.kind || "service",
            amount: (data.amount_total || 0) / 100,
            currency: (data.currency || "usd").toUpperCase(),
          });
          await refresh();
          return;
        }
        if (attempts >= 8) { setStatus("timeout"); return; }
        setTimeout(poll, 2000);
      } catch { setStatus("error"); }
    };
    poll();
    // eslint-disable-next-line
  }, []);

  return (
    <Layout>
      <div className="parchment p-12 text-center" data-testid="booking-success">
        {status === "checking" && <h1 className="font-serif text-4xl">Sealing the working...</h1>}
        {status === "paid" && (
          <>
            <div className="label-mystic mb-2">Booking Confirmed</div>
            <h1 className="font-serif text-5xl text-secondary mb-4">The ritual is paid.</h1>
            <p className="text-foreground/80 mb-2">Total: <span className="font-serif text-secondary">${(info.amount_total/100).toFixed(2)}</span></p>
            <p className="text-foreground/60 text-sm mb-6">Your practitioner will reach out shortly. $CAUL rewards have been credited to your wallet.</p>
            <button onClick={() => nav("/wallet")} className="bg-primary text-primary-foreground px-8 py-3 uppercase tracking-wider text-xs rounded-sm" data-testid="booking-view-wallet">View Wallet</button>
          </>
        )}
        {status === "timeout" && <h1 className="font-serif text-3xl">Still processing — refresh in a moment.</h1>}
        {status === "error" && <h1 className="font-serif text-3xl text-destructive">Could not verify payment.</h1>}
      </div>
    </Layout>
  );
}
